import React from 'react';
import { BrowserRouter, Routes as RouterRoutes, Route } from 'react-router-dom';
import ScrollToTop from './components/ScrollToTop';
import ErrorBoundary from './components/ErrorBoundary';
import Header from './components/Header';
import NotFound from './pages/NotFound';
import Portfolio from './pages/portfolio';
import ContactPage from './pages/contact';
import Websites from './pages/websites';
import Skills from './pages/skills';
import About from './pages/about';
import Homepage from './pages/home';
import PrivacyPolicy from './pages/privacy';
import TermsOfUse from './pages/terms';
import FAQPage from './pages/faq';
import Footer from './components/Footer';

const Routes = () => {
  return (
    <BrowserRouter>
      <ErrorBoundary>
        <ScrollToTop />
        <Header />
        <main className="pt-16">
          <RouterRoutes>
            <Route path="/" element={<Homepage />} />
            <Route path="/portfolio" element={<Portfolio />} />
            <Route path="/contact" element={<ContactPage />} />
            <Route path="/websites" element={<Websites />} />
            <Route path="/skills" element={<Skills />} />
            <Route path="/about" element={<About />} />
            <Route path="/faq" element={<FAQPage />} />
            <Route path="/privacy" element={<PrivacyPolicy />} />
            <Route path="/terms" element={<TermsOfUse />} />
            <Route path="/homepage" element={<Homepage />} />
            <Route path="*" element={<NotFound />} />
          </RouterRoutes>
        </main>
        <Footer />
      </ErrorBoundary>
    </BrowserRouter>
  );
};

export default Routes;
